"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "m12 2-5.5 9h11z"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "17.5",
  cy: "17.5",
  r: "4.5"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M3 13.5h8v8H3z"
}, "2")], 'CategorySharp');